import { CheckCircleOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Modal, notification, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import "../../../../Usuario.style.scss";
// import { useBepsForm } from "../../../../../../hooks/useBepsForm";
import apiParticipantes from "../../../../../../api/Participantes/api-participantes";
import apiBeps from "../../../../../../api/Beps/api-beps";
import { UseVerConvocatorias } from "../../../../../../hooks/UseVerConvocatorias";
import { useNavigate } from "react-router";
import { FormBeps } from "../../../../../../models/Beps/beps.model";
import { initialValuesPostulacionModel } from "../../../../../../models/PostulacionesModel/postulacion.model";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../redux/reducers";
import DocumentosService from '../../../../../../api/Documentos/api-documentos';
import apiRolesPermisos from "../../../../../../api/Roles/api-roles-permisos";
import apiNotificaciones from "../../../../../../api/Notificaciones/api-notificaciones";
import fileDownload from "js-file-download";
import apiDocumentos from "../../../../../../api/Documentos/api-documentos";
import getStorageUser from "../../../../../../middlewares/GetStorageUser"
import { DownloadHTML } from "../../../../../../utils/DownloadFile";
import moment from "moment";

type DocumentosBepsProps = {
  formBeps: FormBeps;
  prevTab: any;
  documentosBeps: any;
  setdocumentosBeps: any;
};
export const DocumentosBeps = ({ prevTab, documentosBeps, setdocumentosBeps, formBeps }: DocumentosBepsProps) => {
  const navigate = useNavigate();
  const { convocatoria, getConvocatoria, idParticipante } = UseVerConvocatorias();
  const { id_postulacion } = useSelector((state: RootState) => state.participantes);
  const { idConvocatoria } = useSelector((state: RootState) => state.convocatoria);
  const [modal, setModal] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [user, setUser] = useState<any>({})

  const getUser = async () => {
    try {
      const user = getStorageUser()
      setUser(user)

    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    getUser();
    getConvocatoria();
    cargarDocumentosBeps();
    
    // getPostulacion();
  }, []);
  // const { documentosBeps, setdocumentosBeps } = useBepsForm();

  const cargarDocumentosBeps = () => {
    console.log(documentosBeps, 'documentosBeps')
    let arrayDocumentos = documentosBeps.filter((d: any) => {
      if (d.tipo_documento === "Encuesta Sisbén" && !formBeps.sisben) {
        return false;
      }

      if (d.tipo_documento === "Cerficiado de discapacidad" && !formBeps.discapacidad_fisica) {
        return false;
      }
      if (d.tipo_documento === "Encuesta Sisbén" && !formBeps.sisben) {
        return false;
      }
      if (d.tipo_documento === "Cetificado de libertad económica" && formBeps.con_quien_reside !== 3) {
        return false;
      }

      return true;
    });

    setdocumentosBeps(arrayDocumentos);
  };

  const componentRef = useRef<any>();

  const handlePrint = () => {
    DownloadHTML(componentRef.current);
  }
  
  // useRef<any>();
  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current,
  //   pageStyle: "pageStyles={'@media print { body { -webkit-print-color-adjust: exact; } @page { size: A4; margin: 200mm !important }}'}"
  // });

  const eliminarArchivo = (e: any, index: number) => {
    let nuevosdocumentos: any = documentosBeps.map((doc: any, indexdoc: number) => {
      if (index === indexdoc) {
        return {
          ...doc,
          url_participante: "",
        };
      }
      return {
        ...doc,
      };
    });
    return setdocumentosBeps(nuevosdocumentos);
  };

  const openNotification = ({ titulo, descripcion, placement }: any) => {
    notification.info({
      message: titulo,
      description: descripcion,
      placement,
    });
  };

  const guardarArchivosTecnicos = async (datos: any, e: any, index: number) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (e.target.files[0].type === "application/pdf") {
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        let data = await DocumentosService.guardarArchivo(formData);
        let nuevosdocumentos: any = documentosBeps.map((doc: any, indexdoc: number) => {
          if (index === indexdoc) {
            return {
              ...doc,
              url_participante: data.data,
            };
          }
          return {
            ...doc,
          };
        });
        document.getElementsByClassName("cards-documentos")[index].classList.remove("border-error-cards-documentos");
        return setdocumentosBeps(nuevosdocumentos);
      } else {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos PDF",
          placement: "bottomRight",
        });
      }
    }
  };

  const guardarycontinuar = async () => {

    let existeUnDocumentoSinLlenar = documentosBeps.filter((d : any)=> d.url_participante == '');

    if (existeUnDocumentoSinLlenar.length > 0) {
      return openNotification({
        titulo: "Error",
        descripcion: "Existen documentos sin anexar",
        placement: "bottomRight",
      });
    }

    setDisabled(true);


    let secuencia = convocatoria.seq_artista;
    let fechaActual = new Date();
    if (convocatoria.tipo === 2) secuencia = convocatoria.seq_jurado
    if (convocatoria.tipo === 3) secuencia = convocatoria.seq_beps
    if (secuencia === null) secuencia = 1;
    let data = await apiParticipantes.crearPostulacion({
      tipo: 3,
      convocatoria_id: idConvocatoria,
      numero_documento_participante: user.documento,
      usuario_id: idParticipante,
      fecha_apertura: moment(fechaActual).format('YYYY-MM-DD'),
      estado: "Inscrito sin revisar",
      nombre_convocatoria: convocatoria.nombre_convocatoria,
      linea_convocatoria: convocatoria.linea_convocatoria,
      documentos_administrativos: documentosBeps,
      secuencia,
    });
    setPostulacion(data.data)
    // console.log(object)
    let notificacionCorreo = {
      tipo_participante: 3,
      tipo_notificacion: "inscripción",
      remitente: idParticipante,
      convocatoria_id: convocatoria.idconvocatorias,
    }
    await apiParticipantes.guardarDocumentosAdministrativosPostulacion(data.data.id_postulacion, documentosBeps);
    setModal(true);
    await apiNotificaciones.enviarNotificacion(notificacionCorreo);
    // navigate("/usuario/");
  };

  const [postulacion, setPostulacion] = useState<any>(initialValuesPostulacionModel)
  // const getPostulacion = async() => {
  //   //
  //   try {
  //     // console.log(postulacion)
  //     const { data } = await apiParticipantes.consultarPostulacion(id_postulacion);
  //     // let dataTranform = data.map((x : any) => {
  //     //   return {
  //     //     ...x,
  //     //     categoria_linea: x.categoria_linea_convocatoria[0].text
  //     //   }
  //     // })


  //     return setPostulacion(data);
  //   } catch (error) {

  //   }
  // }

  const descargarArchivo = async (url: string) => {
    console.log(url)
    let { data }: any = await apiDocumentos.descargarArchivoBeps(url);
    console.log(data)
    fileDownload(data, url);
  };

  const AceptarModal = () => {
    setModal(false);
    return navigate("/usuario/");
  };

  return (
    <>
      <div className="m-0"
        style={{ paddingTop: "16px", paddingBottom: "0%" }}
      >
        <div className="row m-0">
          {documentosBeps.map((data: any, index: number) => {
            return (



              <div key={`contenedor_${index}`} className="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                <div className="row m-0 cards-documentos">

                  <div className="col-12 mt-3 mb-3 font-family-Montserrat-Bold font-size-14px">
                    {data.tipo_documento}
                  </div>
                  <div className="col-12 font-family-Montserrat-Regular font-size-14px">
                    {data.descripcion}
                  </div>
                  {index == 1 && (
                    <div className="col d-flex">
                      <Button
                        className="button-yellow-ghost pe-0 pb-0 m-0 mt-4"
                        style={{ paddingLeft: "0" }}
                        onClick={() => descargarArchivo(data.url_documento)}
                      >
                        DESCARGAR FORMATO
                      </Button>
                    </div>
                  )}
                  <div className="col d-flex justify-content-end">
                    <Button
                      className="button-gray-ghost pe-0 pb-0 m-0 mt-4"
                      onClick={() => {
                        let inputs: HTMLElement = document.getElementsByClassName("inputs-ref")[index] as HTMLElement;
                        inputs.click();
                      }}
                    >
                      CARGAR DOCUMENTO
                    </Button>
                    <input
                      className="inputs-ref"
                      type="file"
                      hidden
                      onChange={(e) => {
                        guardarArchivosTecnicos(data, e, index)
                        e.target.value = ""
                      }}
                    />
                  </div>


                  {data.url_participante && data.url_participante !== "" ? (
                    <div
                      className="row m-0 background-color-00904C position-absolute-card-documento"
                      style={{

                        height: document.getElementsByClassName("cards-documentos")[index].clientHeight,
                      }}
                    >
                      <div

                        className="col-10 mt-3 mb-3 font-family-Montserrat-Bold font-size-14px font-color-FFFFFF"
                      >
                        {data.tipo_documento}
                      </div>
                      <div className="col justify-content-flex-end pe-0 mt-2 font-size-24px font-color-FFFFFF">
                        <CheckCircleOutlined />
                      </div>
                      <div className="col-6 justify-content-flex-end">
                        <Button
                          className="button-blanco-ghost text-uppercase font-family-Montserrat-Regular"
                          style={{ paddingLeft: "0" }}
                          onClick={(e) => eliminarArchivo(e, index)}
                        >
                          Eliminar
                        </Button>
                      </div>
                      <div className="col-6">
                        <Button className="button-blanco-ghost font-family-Montserrat-Bold text-uppercase">Cargado</Button>
                      </div>
                    </div>

                  ) : null}
                </div>
              </div>






            );
          })}

        </div>

      </div>
      <div className="row bg-white"
        style={{
          justifyContent: "center",
          marginTop: "0%",
          position: "sticky",
          bottom: 0,
          paddingBottom: "0%",
        }}
      >
        <div className="col justify-content-flex-end">
          <Button className="button-blanco-radius" style={{ marginRight: "16px" }} onClick={prevTab}>
            Atrás
          </Button>
          <Button className="button-azul-radius" onClick={guardarycontinuar} disabled={disabled}>
            Inscribir propuesta
          </Button>
        </div>

      </div>



      <div>
        <Modal
          style={{ top: 20, zIndex: 3, background: "transparent" }}
          visible={modal}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closable={false}
          closeIcon=""
          width={662}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="row-shadow">
            <div className="row">
              <div className="col-12 font-size-22px font-family-Montserrat-Bold justify-content-center">
                {/* {convocatoria.nombre_convocatoria} */}
                Se ha completado el proceso
              </div>
              <div className="col-12 font-size-16px font-family-Montserrat-Regular justify-content-center">
                Felicidades te has postulado con éxito en la convocatoria beps
              </div>
              {/* <div className="col-12 font-size-16px font-family-Montserrat-SemiBold justify-content-center">

                Puede hacerle seguimiento desde el menú "Mis postulaciones!!!"
              </div> */}
            </div>

            <div className="row justify-content-center align-items-center">
              <div className="col justify-content-flex-end">
                <Button className="button-blanco-radius" onClick={handlePrint}>
                  DESCARGAR
                </Button>
              </div>
              <div className="col justify-content-flex-start" style={{ textAlign: "initial", paddingLeft: "8px" }}>
                <Button className="button-azul-radius" onClick={AceptarModal}>
                  ACEPTAR
                </Button>
              </div>
            </div>
          </div>
          <div className="row-shadow">
            <div className="row p-5" ref={componentRef} style={{ height: "350px", overflowY: "auto" }}>
              <div className="col-6">
                <div className="row">
                  <div className="col-12">
                    Código radicado:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Nombre representante:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Cédula/NIT:
                    <Divider />
                  </div>
                  <div className="col-12">
                    Fecha:
                    <Divider />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="row">
                  <div className="col-12">
                    {postulacion.radicado}
                    <Divider />
                  </div>
                  <div
                    className="col-12"
                    style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}
                  >
                    {user.nombres} {user.apellidos}
                    <Divider />
                  </div>
                  <div className="col-12" style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                    {user.documento}
                    <Divider />
                  </div>
                  <div className="col-12" style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                    {postulacion.fecha_apertura}
                    <Divider />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};
